<template>
  <div class="container">
    <div class="customer-info mt-5" v-if="job.customer">
      <div class="row">
        <div class="col-md-12 avatar-row">
          <img src="/static/img/avatar.1d88924.png" class="customer-avatar" /> <span class="customer-fullName">{{ job.customer.first_name }} {{ job.customer.last_name }}</span> <span v-if="job.customer.contacts && job.customer.contacts.length" class="customer-contacts">+{{ job.customer.contacts.length }}</span>
        </div>
        <div class="col-md-12 mail-row">
          <p><span aria-hidden="true" class="mod-contact-icon mod-icon-email" /> {{ job.customer.email }}</p>
        </div>
        <div class="col-md-12 number-row">
          <p><span aria-hidden="true" class="mod-contact-icon mod-icon-phone" /> {{ phoneMask.maskedPhone(job.customer.phone) }}</p>
        </div>
        <div class="col-md-12 card-row" v-if="job.customer.customer_cards">
          <div v-for="card in job.customer.customer_cards" :key="card.id">
            <span v-if="card.is_default == 1"> <span aria-hidden="true" class="mod-card-icon mod-icon-cc" /> **** **** **** {{ card.card_number }}</span>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <button class="button button-edit" @click="$emit('openM', 'open modal')"><span class="icon-wrapper"><span class="fa fa-pencil pointer edit-icon" /></span> Edit info</button>
        </div>
        <div class="col-md-6 text-center send-btn-row">
          <button class="button button-send flex" @click="toggleSidebar"><span class="icon-wrapper flex align-items-center justify-content-center"><span class="send-icon fa fa-envelope" /></span> Send Email</button>
        </div>
      </div>
    </div>
    <div v-else class="p-3" style="background-color: #f8d7d9">
      <h6>Deleted <br /> Customer</h6>
    </div>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar">
        <send-claim-email
          class="sidebar-right"
          @cancel="toggleSidebar()"
          @update="$emit('update')"
          :job="job"
          :type-id="1"
        />
      </div>
    </transition>

    <vue-content-loading v-if="!job">
      <circle cx="30" cy="30" r="30" />
      <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
    </vue-content-loading>
  </div>
</template>

<script>
import PhoneMask from '../../classes/PhoneMask';
import SendClaimEmail from '../claims/Modals/SendClaimEmail';

export default {
  name: 'CustomerInfo',
  components: {
    SendClaimEmail,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    showMore: false,
    showCustomerModal: false,
    showCreateSidebar: false,
    phoneMask: new PhoneMask(),
  }),
  methods: {
    toggleSidebar() {
      this.showCreateSidebar = !this.showCreateSidebar;
    },
  },
};
</script>
<style scoped>
.customer-info p {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #212529;
}
.customer-contacts {
  color: #2962ff;
  font-size: 13px;
  border-radius: 4px;
  background-color: #e9efff;
  padding: 3px;
}
.avatar-row {
  padding-bottom: 16px;
}
.mail-row p,
.number-row p {
  margin-bottom: 12px;
}
.card-row div:last-of-type {
  margin-bottom: 16px;
}
.customer-avatar {
  width: 36px;
  border-radius: 50% !important;
  margin-right: 12px;
}
.mod-card-icon {
  width: 16px;
  height: 12px;
  display: inline-block;
}
.mod-contact-icon {
  width: 14px;
  height: 14px;
  display: inline-block;
}
.customer-fullName {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}
.send-btn-row {
  border-left: solid 1px #cdd1d6;
}
.button {
  border: none;
  background: transparent;
  color: #2962ff;
}
.edit-icon {
  width: 12px;
  height: 12px;
}
.icon-wrapper {
  background-color: rgba(41, 98, 255, 0.1);
  border-radius: 4px;
  padding: 7px;
  margin-right: 8px;
  width: 24px;
  height: 24px;
}
.send-icon {
  width: 16px;
  height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/customers/CustomerInfo.vue